import { render, staticRenderFns } from "./TestStreamPage.vue?vue&type=template&id=33945b4e"
import script from "./TestStreamPage.vue?vue&type=script&lang=js"
export * from "./TestStreamPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports